"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import React from "react"
import { sendBlockEvent } from "utils/gtm"
import ButtonWithArrow from "../common/bit/ButtonWithArrow"
import { useIsMediumDesktop } from "../common/bit/MediaQueries"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import { colors, mediaQueries, sizes } from "../theme/theme"
import ImageDetailsCard, { CardProps } from "./ImageDetailsCard"

interface ImageCardListProps {
  itemsList: CardProps[]
  button?: {
    links: {
      target?: string | undefined
      url: string
      name: string
    }[]
  }
  desktopCardHeight?: string
}

const StyledButtonWithArrow = styled(ButtonWithArrow)`
  padding: 10px 18px;
  ${mediaQueries.mobile} {
    margin: 40px;
  }
  ${mediaQueries.tablet} {
    margin: 40px;
  }
  ${mediaQueries.desktop} {
    padding: ${sizes.baseDouble} ${sizes.baseTriple};
  }
`
const StyledSwiperOnMobile = styled(SwiperOnMobile)`
  ${mediaQueries.desktopM} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${sizes.baseSepta};
  }
  ${mediaQueries.desktopXl} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${sizes.baseSepta};
  }
`

const StyledImageDetailsCardWrapper = styled(Box)`
  width: 100%;
  height: 100%;
`

interface GTMBlockProps {
  blockId?: string
  blockTitle?: string
}

const GTM_BLOCK_ID = "8" // As per business requirement for this block
const GTM_BLOCK_TITLE = "ורוצים לתת לך את הידע הזה"

const ImageDetailsCardList: React.FC<
  React.PropsWithChildren<ImageCardListProps> & GTMBlockProps
> = ({
  itemsList,
  button,
  desktopCardHeight,
  blockId = GTM_BLOCK_ID,
  blockTitle = GTM_BLOCK_TITLE,
}) => {
  const isMediumDesktop = useIsMediumDesktop()
  const desktopItemsGap = isMediumDesktop ? "7px" : undefined
  if (!itemsList) return null
  const handleCardClick = (item: CardProps) => {
    sendBlockEvent({
      blockId,
      componentName: "תוכן",
      title: blockTitle,
      buttonName: (item?.link?.name as unknown as string) || item?.title || "",
    })
  }
  const handleButtonClick = () => {
    sendBlockEvent({
      blockId,
      componentName: "תוכן",
      title: blockTitle,
      buttonName: button?.links[0]?.name,
    })
  }
  return (
    <>
      <StyledSwiperOnMobile
        swiperProps={{
          spaceBetween: 20,
          slidesPerView: 1,
          centeredSlides: true,
          navigation: false,
        }}
        desktopItemsGap={desktopItemsGap}
        desktopCardHeight={desktopCardHeight}
      >
        {itemsList.map((item: CardProps, index: number) => {
          return (
            <StyledImageDetailsCardWrapper
              key={`image-card-item-${item?.title}-${index}`}
              onClick={() => handleCardClick(item)}
            >
              <ImageDetailsCard
                data={item}
                index={index}
                desktopCardHeight={desktopCardHeight}
              />
            </StyledImageDetailsCardWrapper>
          )
        })}
      </StyledSwiperOnMobile>
      {button && (
        <StyledButtonWithArrow
          href={getNonUmbracoUrl(button?.links[0].url)}
          target={button?.links[0]?.target ? button?.links[0]?.target : "_self"}
          onClick={handleButtonClick}
        >
          <Typography variant="CTA" color={colors.white}>
            {button?.links[0]?.name}
          </Typography>
        </StyledButtonWithArrow>
      )}
    </>
  )
}

export default ImageDetailsCardList
